import styles from "./Second.module.css";
import Bio from "../components/bio/Bio";
import { useState, useEffect, useCallback } from "react";

function Second({ aboutmeRef }) {
  // const [image, setImage] = useState("portfolio2.png");
  const [backgroundColor, seBackgroundColor] = useState("");

  // const changeImageHandler = useCallback(() => {
  //   if (image === "/portfolio2.png") {
  //     setImage("/portfolio1.png");
  //     seBackgroundColor(styles.secondprofile);
  //   } else {
  //     setImage("/portfolio2.png");
  //     seBackgroundColor("");
  //   }
  // }, [image]);

  // useEffect(() => {
  //   const timer = setTimeout(changeImageHandler, 5000);
  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [changeImageHandler]);

  return (
    <div ref={aboutmeRef} className={styles.secondsection}>
      <h1 className={styles.title}>01. ABOUT ME</h1>
      <div className={styles.content}>
        <Bio />
        <div className={`${styles.profile} ${backgroundColor}`}>
          {/* <img src={image} alt={image} key={image}/> */}
          <img src="/portfolio2.png" alt="/portfolio2.png" />
        </div>
      </div>
    </div>
  );
}
export default Second;
